import { Component, OnInit } from '@angular/core';
import { MdcService } from '../shared/mdc/mdc.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  version: string = '';

  constructor(private mdcService: MdcService) { }

  ngOnInit(): void {
    this.version = this.mdcService.version
  }
}